import Layout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import AddUtmContainer from '../containers/Utm/AddUtm.container'

const AddUtm = () => {
  return (
    <Layout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
      title='Unidad Tributaria Mensual (UTM)'
      description='Los valores UTM vienen solos desde el SII. No hace falta cargarlos a mano.'
    > 
      <AddUtmContainer />
    </Layout>
  )
}

export default AddUtm
